export default __webpack_public_path__ + "static/builder-a3b05839326ce7cde857773a6d209d1a.png";